import { Link, useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import "../css/font-awesome.css"
import "bootstrap/dist/css/bootstrap.css"
import "../css/style.css"
import gifLogo from "../images/gif-transparentBG.gif"
import textLogo from "../images/Chofly-Elite.png"
import youTubePlayButton from "../images/YouTubePlayButton.png"
// import logo from "../images/logo.png"
import TopNav from "../components/TopNav"
import { Carousel } from "antd";
import Img from 'gatsby-image'

const Header = () => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      header {
        social_media_logo_links {
          logo {
            url
            type
            width
            size
            height
            id
            fileName
            extension
          }
          text_next_to_logo
          hover_text
          link
        }
      }

      allYoutubeVideo(filter: {title: {regex: "/^((?!#shorts).)*$/"}, channelId: {eq: "UCDClIEc8CVfPz8nA8lVHiQQ"},}) {
          edges {
            node {
              localThumbnail {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
              videoId
              title
              originalID
              id
              description
              channelTitle
              channelId
              publishedAt
              privacyStatus
              thumbnail {
                height
                url
                width
              }
            }
          }
          nodes {
            title
            videoId
            thumbnail {
              height
              url
              width
            }
          }
        }

        allNews(sort: {fields: flotiqInternal___createdAt, order: DESC}, filter: {publish: {eq: true}}) {
          nodes {
            id
            slug
            title
            titleClass
            seoTitle
            content
            featured_image {
              url
              id
              extension
            }
            publish
            change_link
          }
        }


    }
  `)


const size = 2
const TwoMostRecentYouTubeVideosWithGoodThumbnails = data.allYoutubeVideo.edges.slice(0, size)


    return (
      <>
        <header className="site-header">
          {/*<div className="notice">Free Shipping or 20% off order for contact-free pick-up (<a href="/contact">Contact me</a> before ordering for 20% off discount code)</div>*/}
            <ul className="navbar-nav mr-auto header-menu">
              <div className="TopNav">
                <TopNav />
              </div>
            </ul>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-4 align-self-center">
                <Link className="header-logo" alt="Chofly Elite" title="Chofly Elite - Click to go to Home page." to="/">
                  <img className="gifLogo" src={gifLogo} alt="ChoseN"></img>
                  <img className="textLogo" src={textLogo} alt="Chofly Elite"></img>
                </Link>
              </div>
              <div className="col-sm-12 col-md-8 align-self-center">
              </div>
              <div className="social-icons-wrap on-inner-pages-only">
                <div className="social-icons">
                  {data.header.social_media_logo_links.map(items => (
                    <a key={items.id} href={items.link} className={items.link ? <></> : "hidden" } target="_blank" rel="noopener" alt={items.hover_text} title={items.hover_text}><img src={`${'https://api.flotiq.com'}${items.logo[0].url}`} width="25" height="25" alt={items.hover_text} title={items.hover_text} /><span>{items.text_next_to_logo}</span></a>
                  ))}
                </div>
              </div>
              {/* <div className="center-image-overlay-link-wrap"><Link to="/" alt="Chofly Elite" title="Chofly Elite - Click to go to Home page."><div className="center-image-overlay-link"></div></Link></div> */}
            </div>
          </div>
        </header >
        <div className="HomePageNewsAndVideos-wrap-container">
          {/* <div className="HomePageNewsAndVideos-wrap CarouselHeader">
            <div className="NewsCarousel-wrap">
              <h2 className="tealHeading">LATEST NEWS</h2>
            </div>
            <div className="right horizontal-split">
              <h2 className="tealHeading">LATEST VIDEOS</h2>
            </div>
          </div> */}
          <div className="HomePageNewsAndVideos-wrap">
            <div className="NewsCarousel-wrap">
              <div className="NewsCarousel-wrap">
                <h2 className="tealHeading"><Link class="textLink" to="/news">LATEST NEWS</Link></h2>
              </div>
              {/* {data.allNews.nodes.map(items => ( */}
                <h2 className="tealHeading right">{/* <Link class="textLink" to={`/news/${items.slug}`}> */}Click Image to read more!{/*</Link>*/}</h2>
              {/* ))} */}
            {/* <Carousel autoplay> */}

              
                
                {/* <img src="https://api.flotiq.com/image/0x0/_media-0ab37ab9-3b31-4b38-b7f1-9b330bf976b4.jpg" /> */}
                {data.allNews.nodes ?
                  <>
                    <Carousel autoplay>
                      {data.allNews.nodes.map(items => (
                          <div className="CarouselItem">
                          {items.change_link ?
                            <Link to={`${items.change_link}`}>
                              <img src={`${'https://api.flotiq.com'}${items.featured_image[0].url}`} />
                            
                            <h2 className={`title ${items.titleClass}`}><span dangerouslySetInnerHTML={{__html: items.title}} /></h2>
                            {/* <h2 className="title"><span>Chofly Elite v2.0<br /> is Live!</span></h2> */}
                            </Link>
                          :
                            <Link to={`/news/${items.slug}`}>
                              <img src={`${'https://api.flotiq.com'}${items.featured_image[0].url}`} />
                            
                            <h2 className={`title ${items.titleClass}`}><span dangerouslySetInnerHTML={{__html: items.title}} /></h2>
                            {/* <h2 className="title"><span>Chofly Elite v2.0<br /> is Live!</span></h2> */}
                            </Link>
                          }
                          </div>
                      ))}
                    </Carousel>
                  </>
                :
                  <>
                    <img src={`${'https://api.flotiq.com'}${data.allNews.nodes[0].featured_image[0].url}`} />
                  </>
                }
          </div>
          <div className="NewsCarousel-wrap outside-horizontal-split">
                <h2 className="tealHeading"><a href="https://www.youtube.com/c/ChoflyElite/videos?view=0&sort=dd&flow=grid" target="_blank" rel="noopener noreferrer" alt="Click here to view all my latest videos in a new a tab" title="Click here to view all my latest videos in a new a tab">LATEST VIDEOS</a></h2>
          </div>
          <div className="right horizontal-split">
              <div className="NewsCarousel-wrap inside-horizontal-split">
                <h2 className="tealHeading"><a href="https://www.youtube.com/c/ChoflyElite/videos?view=0&sort=dd&flow=grid" target="_blank" rel="noopener noreferrer" alt="Click here to view all my latest videos in a new a tab" title="Click here to view all my latest videos in a new a tab">LATEST VIDEOS</a></h2>
              </div>

                {TwoMostRecentYouTubeVideosWithGoodThumbnails ?
                  <>
                    {TwoMostRecentYouTubeVideosWithGoodThumbnails.map((video, index) => (
                      <a key={index} href={`https://www.youtube.com/watch?v=${video.node.videoId}`} className="YouTubeItems" target="_blank" rel="noopener noreferrer" alt="Click to view in new tab" title="Click to view in new tab">
                        <div className="CarouselItem videoThumb">
                          <img className="youTubeThumb" src={`https://i.ytimg.com/vi/${video.node.videoId}/maxresdefault.jpg`} />
                          <img className="youTubePlayButton" src={youTubePlayButton} />
                        </div>
                      </a>
                    ))}
                  </>
                :
                  <></>
                }

              {/* <a href={`https://www.youtube.com/watch?v=${data.allYoutubeVideo.edges[0].node.videoId}`} className="YouTubeItems" target="_blank" rel="noopener noreferrer" alt="Click to view in new tab" title="Click to view in new tab">
              <div className="CarouselItem">
                              <Img
                    fluid={data.allYoutubeVideo.edges[0].node.localThumbnail.childImageSharp.fluid}
                    className="youTubeThumb"
                    loading="eager"
                    objectFit="cover"
                    objectPosition="50% 50%"
                    alt={data.allYoutubeVideo.edges[0].node.title}
                    title={data.allYoutubeVideo.edges[0].node.title}
                    aspectRatio="0.5625"
                  />
                <img className="youTubeThumb" src={`https://i.ytimg.com/vi/${data.allYoutubeVideo.edges[0].node.videoId}/maxresdefault.jpg`} />
                <img className="youTubePlayButton" src={youTubePlayButton} />
                <h4 className="youTubeVideoTitle">{data.allYoutubeVideo.edges[0].node.title}</h4>
              </div>
            </a>
            <a href={`https://www.youtube.com/watch?v=${data.allYoutubeVideo.edges[1].node.videoId}`} className="YouTubeItems" target="_blank" rel="noopener noreferrer" alt="Click to view in new tab" title="Click to view in new tab">
              <div className="CarouselItem">
                <img className="youTubeThumb" src={data.allYoutubeVideo.edges[1].node.thumbnail.url} />
                <img className="youTubeThumb" src={`https://i.ytimg.com/vi/${data.allYoutubeVideo.edges[1].node.videoId}/maxresdefault.jpg`} />
                <img className="youTubePlayButton" src={youTubePlayButton} />
                <h4 className="youTubeVideoTitle">{data.allYoutubeVideo.edges[1].node.title}</h4>
              </div>
            </a> */}            

          </div>
        </div>
        <div className="social-icons-wrap">
          <div className="social-icons">
            {data.header.social_media_logo_links.map(items => (
              <a key={items.id} href={items.link} className={items.link ? <></> : "hidden" } target="_blank" rel="noopener" alt={items.hover_text} title={items.hover_text}><img src={`${'https://api.flotiq.com'}${items.logo[0].url}`} width="25" height="25" alt={items.hover_text} title={items.hover_text} /><span>{items.text_next_to_logo}</span></a>
            ))}
          </div>
        </div>
        <div className="LightLine-wrap">
          <span>Live Content Below</span>
          <img src="/LightLine.png" /></div>
      </div>
    </>
    )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}


export default Header
